<template>
  <div>
    <div class="column is-3 is-paddingless-left is-paddingless-top is-paddingless-bottom is-padding-right-xsmall">
      <r-label :label="'Type d\'annexe'" :value="a.annex_type" :from-flux="fromFlux"></r-label>
      <div class="field">
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="a.annex_type">
              <option :value="null">Selectionnez le type</option>
              <option v-for="c in annexesList" :value="c.value" :key="c.value">{{c.label}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-2 is-padding-right-xsmall is-paddingless-left is-paddingless-top is-paddingless-bottom">
      <div class="field">
        <label class="label" for="remuneration">Surf. m² <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
        <div class="control">
          <v-input :id="'annex_surface' + a.index" :name="'annex_surface' + a.index" @input="val => a.surface = val"
                  :model="a.surface" input-type="number" :number="true"
                  :errors-bag="errors" data-vv-value-path="val"
                  data-vv-as="Surface">
          </v-input>
        </div>
      </div>
    </div>
    <div class="column is-7 is-padding-right-xsmall is-paddingless-left is-paddingless-top is-paddingless-bottom">
      <label class="label" for="remuneration">Détails / Informations / N° <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <v-input :id="'annex_info' + a.index" :name="'annex_info' + a.index" @input="val => a.info = val"
                  :model="a.info"
                  :errors-bag="errors" data-vv-value-path="val"
                  data-vv-as="Infos">
          </v-input>
        </div>
        <div class="control">
          <a @click="remove(a.index)" class="button is-square is-grey is-inverted is-border">
            <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="column is-1 is-paddingless-left is-padding-top-xsmall is-paddingless-bottom">
      <div class="field">
        <label class="label">&nbsp;<span class="is-size-3 is-margin-left-xsmall"><i class="fal fa-xs fa-fake has-text-grey"></i></span></label>
        <a @click="remove(a.index)"
          class="button is-circle is-border is-margin-right is-margin-neg-top has-text-grey">
          <i class="fas fa-trash fa-lg"></i>
        </a>
      </div>
    </div> -->
    <div style="display: none;">
      <div class="field">
        <div class="control">
          <v-input :id="'annex_is_parking' + a.index" :name="'annex_is_parking' + a.index" @input="val => a.is_parking = val"
                  :model="a.is_parking"
                  :errors-bag="errors" data-vv-value-path="val"
                  data-vv-as="Infos">
          </v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '../../mixins'

  export default {
    name: 'AnnexeItem',
    mixins: [DefaultValues],
    props: {
      source: {
        type: Object,
        required: true,
        default: () => {}
      },
      fromFlux: Boolean
    },
    computed: {
      a () {
        return Object.assign(this.source)
      }
    },
    methods: {
      remove () {
        this.$emit('remove', this.a.index)
      }
    }
  }
</script>

<style scoped>
.icon.is-small {
  height: .1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/lot/AnnexeItem.vue